import type { LocaleStrings } from "../types.ts";

export const frLocale: LocaleStrings = {
  game: {
    defaultClanName: "Ton clan",
    clanSetupTitle: "Crée ton clan",
    clanSetupNameLabel: "Nom du clan",
    clanSetupNamePlaceholder: "Entre un nom",
    clanSetupConfirm: "Confirmer",
    settleConfirm: "Continuer",
    promptConfirmStart: "Commencer ici ?",
    startTileConfirm: "Confirmer",
    startTileCancel: "Annuler",
    clanSetupTotemLabel: "Totem",
    promptClanSetup: "Nomme ton clan, choisis un totem et confirme pour choisir une tuile de départ.",
    statsHeaderFormat: "{clanName} · {turnLabel} {turn}",
    promptSelectStart: "Choisis où ton clan doit commencer.",
    promptClanEstablished: "Clan établi.",
    promptEndTurn: "Termine ton tour quand tu es prêt.",
    promptNewTurn: "Déplace-toi sur une tuile adjacente ou termine ton tour.",
    promptVictory: "Ton clan prospère !",
    promptDefeat: "Ton clan a faim.",
    tileContentsFormat: "{terrain} — {food} nourriture/tour",
    tileContentsReducedFormat: "{terrain} — {effective}/{base} nourriture/tour",
    tileTravelingFormat: "{terrain} — en voyage, pas de récolte ce tour",
    turnLabel: "Tour",
    dayNightLabels: {
      day: "Jour",
      dusk: "Crépuscule",
      night: "Nuit",
      dawn: "Aube",
    },
    seasonLabels: {
      spring: "Printemps",
      summer: "Été",
      autumn: "Automne",
      winter: "Hiver",
    },
    temperatureFormat: "{value}°C",
    weatherLabels: {
      clear: "Clair",
      cloudy: "Nuageux",
      overcast: "Couvert",
      rainy: "Pluvieux",
      snowy: "Neigeux",
    },
    populationLabel: "Population",
    foodLabel: "Nourriture",
    waterLabel: "Eau",
    ambientPredatorsLabel: "Prédateurs",
    ambientPredatorLevelLabels: {
      none: "Aucun",
      low: "Faible",
      medium: "Moyen",
      high: "Élevé",
    },
    populationProgressFormat: "{current} / {max}",
    foodGrowthHintFormat: "→ croissance à {threshold}",
    statsCollapsedChipFormat: "Tour {turn} · {population} · {food} · {water} · {predators}",
    endTurnLabel: "Fin du tour",
    terrainNames: {
      ["desert"]: "Désert",
      ["mountain"]: "Montagne",
      ["swamp"]: "Marais",
      ["forest"]: "Forêt",
      ["plains"]: "Plaine",
      ["river"]: "Rivière",
    },
    totemNames: {
      carved: "Sculpté",
      antler: "Bois de cerf",
      spiral: "Spirale",
    },
    victoryTitle: "Victoire !",
    victoryMessage: "Ton clan a atteint 30 personnes. Une vraie civilisation commence.",
    victoryRecapLineFormat: "{label} : {value}",
    victoryRecapTurns: "Tours avant la victoire",
    victoryRecapPopulation: "Population",
    victoryRecapFood: "Nourriture",
    victoryRecapStartTerrain: "Terrain de départ",
    victoryRecapEndTerrain: "Terrain final",
    victoryRecapExplored: "Carte explorée",
    victoryRecapExploredFormat: "{explored} / {total} cases",
    defeatTitle: "Défaite",
    defeatMessage: "Les derniers de ton peuple ont disparu.",
    startAgain: "Recommencer",
    resetLabel: "Réinitialiser",
    exitGame: "Quitter le jeu",
    settingsTitle: "Paramètres",
    settingsCloseAriaLabel: "Fermer les paramètres",
    languageLabel: "Langue",
    sfxVolumeLabel: "Effets sonores — {level}",
    debugModeOff: "Mode debug désactivé",
    debugModeOn: "Mode debug activé",
    fullscreenOff: "Plein écran désactivé",
    fullscreenOn: "Plein écran activé",
    foodOverlayOff: "Afficher la nourriture sur la carte",
    foodOverlayOn: "Masquer la nourriture sur la carte",
    waterOverlayOff: "Afficher l'eau sur la carte",
    waterOverlayOn: "Masquer l'eau sur la carte",
    promptBannerHide: "Masquer la bannière d'instructions",
    promptBannerShow: "Afficher la bannière d'instructions",
    stagingBadgeLabel: "Staging",
    hudSettingsTooltip: "Ouvrir les paramètres",
    hudNotificationsTooltip: "Ouvrir les notifications",
    notificationMarkDone: "Marquer comme terminé",
    notificationOk: "OK",
    notificationCancel: "Annuler",
    closeAriaLabel: "Fermer",
    leaveConfirmTitle: "Enregistrer et quitter ?",
    leaveConfirmBody:
      "Votre progression sera enregistrée. Vous pourrez reprendre cette partie depuis l'écran d'accueil.",
    leaveConfirmSave: "Enregistrer et quitter",
    leaveConfirmStay: "Rester en jeu",
    leaveConfirmSaveFailed:
      "Impossible d'enregistrer la partie. Libérez de l'espace dans le navigateur et réessayez.",
    notificationEmpty: "Aucune notification pour le moment.",
    notificationPageOf: "{current} / {total}",
    notificationPageIndicatorOf: "({current} / {total})",
    notificationSwampTitle: "Marais",
    notificationSwampBody: "Ton clan est entré dans un marais. Le sol est détrempé et avancer ici semble plus lent.",
    notificationFireTitle: "Feu découvert",
    notificationFireBody:
      "Ton clan a trouvé du feu sur cette case—une découverte rare en explorant la carte.",
    notificationFoodDepletionTitle: "Terre épuisée",
    notificationFoodDepletionBody:
      "Rester sur la même case réduit sa production de nourriture. Pars et laisse la terre se régénérer avec le temps.",
    notificationTutorialTurnsTitle: "Votre premier tour",
    notificationTutorialTurnsBody:
      "Déplace-toi sur une tuile adjacente, ou termine ton tour quand tu es prêt.",
    notificationTutorialStatsTitle: "Les stats du clan",
    notificationTutorialStatsBody:
      "Le panneau en haut à gauche affiche le tour, le moment de la journée, la saison, la température, la météo, la population, la nourriture, l'eau et les prédateurs sur ta case. Appuie sur E ou sur Terminer le tour quand tu es prêt à récolter et avancer.",
    notificationTutorialWinGoalTitle: "Comment gagner",
    notificationTutorialWinGoalBody:
      "Fais grandir ton clan jusqu'à 30 personnes pour gagner. Si la population tombe à zéro, le clan est perdu.",
    notificationTutorialFoodEconomyTitle: "Nourriture chaque tour",
    notificationTutorialFoodEconomyBody:
      "Quand tu termines ton tour, la case produit de la nourriture. La population mange d'abord—le reste s'ajoute ou se retire des réserves.",
    notificationTutorialTileFoodTitle: "Lire une case",
    notificationTutorialTileFoodBody:
      "Chaque case révélée montre le terrain et la nourriture par tour. Explore avant de t'installer—des tuiles fertiles comme plaines et rivières nourrissent plus longtemps.",
    notificationTutorialGrowthTitle: "Croissance",
    notificationTutorialGrowthBody:
      "Quand les réserves restent hautes plusieurs tours d'affilée, la population augmente de un.",
    notificationTutorialFamineTitle: "Faim",
    notificationTutorialFamineBody:
      "Si le clan a faim trop longtemps, tu perds une personne. Déplace-toi vers des cases fertiles et accumule des réserves.",
    notificationTutorialOneMoveTitle: "Se déplacer chaque tour",
    notificationTutorialOneMoveBody:
      "Appuie sur 1–6 ou clique une case adjacente surlignée par tour, ou reste sur place. Rester trop longtemps épuise la terre.",
    notificationTutorialFoodOverlayTitle: "Nourriture sur la carte",
    notificationTutorialFoodOverlayBody:
      "Appuie sur F ou utilise le bouton grain sur le HUD pour afficher la nourriture sur les cases révélées.",
    notificationTutorialLandRecoveryTitle: "La terre se régénère",
    notificationTutorialLandRecoveryBody:
      "Les cases que tu quittes regagnent de la nourriture avec le temps. Continue de bouger pour ne pas épuiser un seul endroit.",
    notificationTutorialSettingsTitle: "Paramètres",
    notificationTutorialSettingsBody:
      "Appuie sur S ou ouvre l'engrenage pour changer la langue, ajuster les effets sonores, activer le plein écran, recommencer ou revenir à l'écran d'accueil.",
    notificationTutorialRandomEventsTitle: "Événements sur la carte",
    notificationTutorialRandomEventsBody:
      "Des événements inattendus peuvent apparaître en explorant. Appuie sur N ou ouvre la cloche pour lire ce qui s'est passé.",
    languageLabels: {
      en: "Anglais",
      it: "Italien",
      fr: "Français",
      es: "Espagnol",
      pt: "Portugais",
      de: "Allemand",
      zh: "Chinois",
      nl: "Néerlandais",
    },
  },
  site: {
    gameTitle: "Dawn of Clans",
    kofiButtonLabel: "Me soutenir sur Ko-fi",
    discordLinkLabel: "Rejoindre Discord",
    landing: {
      primaryDescription:
        "Dawn of Clans est un jeu de grande stratégie où tu guides un clan préhistorique à travers la survie, la découverte et l'évolution sociale.",
      secondaryDescription:
        "En commençant avec un petit groupe nomade, tu débloqueras des technologies grâce à l'expérience, t'adapteras aux environnements changeants et façonneras l'émergence des premières civilisations.",
      earlyAccessLabel: "Accès anticipé",
      earlyAccessNotice:
        "En développement précoce. La boucle de survie de base est jouable aujourd'hui ; des systèmes stratégiques plus profonds arrivent.",
      learnMoreLabel: "En savoir plus",
      releaseNoticeText: "Une nouvelle version vient d'être publiée !",
      playLabel: "Jouer",
      continueLabel: "Continuer",
      savedGameSummary: "Tour {turn}, Population {population}",
      resumeModalTitle: "Partie enregistrée",
      newGameLabel: "Nouvelle partie",
      loadingLabel: "Chargement...",
      changelogLink: "Journal des mises à jour",
      careerTeaserFormat:
        "{wins} victoires · record : {fastest} tours · plus exploré : {explored}",
      careerViewChronicleLabel: "Voir la chronique des victoires",
      chronicleModalTitle: "Chronique des victoires",
      chronicleModalCloseLabel: "Fermer",
      chronicleEntryFormat: "{clanName} · {turns} tours · {date}",
      chronicleClearWinHistoryLabel: "Effacer l'historique des victoires",
      chronicleClearWinHistoryBody:
        "Cela supprime toutes les victoires enregistrées sur cet appareil. La partie en cours n'est pas affectée.",
      chronicleClearWinHistoryConfirm: "Oui, effacer l'historique",
      chronicleClearWinHistoryCancel: "Annuler",
      settingsGearAriaLabel: "Paramètres",
      settingsCloseAriaLabel: "Fermer les paramètres",
    },
    about: {
      pageTitle: "À propos de Dawn of Clans",
      backLinkLabel: "← Retour à Dawn of Clans",
      sections: [
        {
          heading: "Aperçu",
          body: "Dawn of Clans est un jeu de grande stratégie où tu guides un clan préhistorique à travers la survie, la découverte et l'évolution sociale. En commençant avec un petit groupe nomade, tu débloqueras des technologies grâce à l'expérience, t'adapteras aux environnements changeants et façonneras l'émergence des premières civilisations.",
        },
        {
          heading: "Ton clan",
          body: "Au début d'une nouvelle partie, donne un nom à ton clan puis choisis où t'installer sur la carte hexagonale. Après avoir fondé ton premier campement, suis le tour, la population et la nourriture dans le panneau de stats. Termine chaque tour pour nourrir ton clan et décide si tu déplaces sur une tuile adjacente avant le tour suivant.",
        },
        {
          heading: "Progression",
          body: "Chaque terrain produit une quantité différente de nourriture à chaque tour. Quand tes stocks restent assez élevés plusieurs tours d'affilée, ta population grandit ; si ton clan reste affamé trop longtemps, des gens sont perdus. Constitue des réserves sur des tuiles fertiles comme les rivières et les plaines, puis fais grandir ton clan jusqu'à trente personnes pour gagner. Si ta population tombe à zéro, le clan disparaît.",
        },
        {
          heading: "Le monde",
          body: "Explore une carte hexagonale où les tuiles sont cachées au départ. Clique pour révéler désert, montagne, marais, forêt, plaine et rivière. Choisis où établir ton premier campement, puis déplace-toi d'une tuile adjacente par tour. Les terres fertiles nourrissent plus de bouches ; les terres hostiles épuisent vite tes réserves.",
        },
        {
          heading: "Statut",
          body: "Dawn of Clans est en développement précoce. Exploration, installation, nourriture et population au tour par tour, et victoire ou défaite sont jouables aujourd'hui. Des systèmes stratégiques plus profonds sont encore en construction.",
        },
      ],
      communitySection: {
        heading: "Communauté",
        body: "Discute avec d'autres joueurs, partage tes retours et suis les mises à jour du développement sur notre serveur Discord.",
      },
      supportSection: {
        heading: "Soutenir le projet",
        body: "Tu aimes Dawn of Clans ? Les dons optionnels sur Ko-fi aident à financer le développement.",
      },
    },
    changelog: {
      pageTitle: "Journal des mises à jour",
      backLinkLabel: "← Retour à Dawn of Clans",
      loadError: "Impossible de charger le journal.",
      emptyState: "Aucune version publiée.",
    },
  },
};
